import { NavbarItem } from '@heroui/navbar';
import { Link } from '@heroui/link';
import Icon from '@/components/Common/Icons/Icon';
import { NextUI } from '@/components/NextUI';
import React from 'react';
import { useAppDispatch } from '@/hooks/redux';
import { showSide } from '@/store/slices/sideSlice';
import { useTranslations } from 'next-intl';
import { sideKey } from '@/components/Common/Sides/types';
import {
  logHubxEvent,
  APP_EVENTS,
  COMMON_EVENTS,
} from '@/lib/analytics/services/log-hubx-event';
import usePaddlePricing from '@/features/subscription/hooks/usePaddlePricing';
import { setTypeForUserAccessLevel } from '@/store/slices/userAccessSlice';
import { getPrimaryPrice } from '@/helpers/pricing-helper';

const UnauthenticatedNav = () => {
  const dispatch = useAppDispatch();
  const translate = useTranslations();
  const openSide = (sideKey: string) => {
    dispatch(showSide({ sideKey: sideKey as sideKey }));
  };
  const { yearlyPrices, monthlyPrices, weeklyPrices } = usePaddlePricing();

  return (
    <div className={'flex items-center gap-10'}>
      <NavbarItem className={'[&_a]:navbar-link'}>
        <Link
          className="!font-normal cursor-pointer flex gap-1"
          onClick={() => {
            openSide('login');
            logHubxEvent({ eventName: APP_EVENTS.BTN_HEADER_LOGIN });
          }}
        >
          <Icon name="UserIcon" width={16} />
          <span className="text-[17px]"> {translate('navbar.login')}</span>
        </Link>
      </NavbarItem>

      {/* <NavbarItem>
        <NextUI.Button
          onClick={() => {
            dispatch(
              showSide({
                sideKey: 'register',
                sideData: { openPaywall: false },
              })
            );
            logHubxEvent({ eventName: APP_EVENTS.BTN_HEADER_FREE_TRIAL });
            dispatch(setTypeForUserAccessLevel('header_free_trial'));
            const primaryPrice = getPrimaryPrice({
              yearlyPrices,
              monthlyPrices,
              weeklyPrices,
            });

            logHubxEvent({
              eventName: COMMON_EVENTS.PURCHASE_BUTTON_CLICK,
              event_params: {
                paywallType: 'header_free_trial',
                currency: primaryPrice?.unit_price?.currency_code,
                amount: (primaryPrice?.unit_price?.amount ?? 0) / 100,
                product_id: primaryPrice?.product_id!,
              },
            });
          }}
          className="min-w-[150px]"
        >
          {translate('navbar.free_trial')}
        </NextUI.Button>
      </NavbarItem> */}
    </div>
  );
};

export default UnauthenticatedNav;
